import { render, staticRenderFns } from "./WizardSettings.vue?vue&type=template&id=d1543f76&"
import script from "./WizardSettings.vue?vue&type=script&lang=js&"
export * from "./WizardSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports